import React, { useState,useEffect } from "react";
import Tabs from "../../Components/Tabs";
import ExpenseManagementController from "../Controllers/ExpenseManagementController";
import AccountDashboardScreen from "./AccountDashboardScreen";
import ExpenseListScreen from "./ExpenseListScreen";
import DisbursementsListScreen from "./DisbursementsListScreen";
import ExpenseApprovalsScreen from "./ExpenseApprovalsScreen";
import DisbursementApprovalsScreen from "./DisbursementsApprovalsScreen";
import AccountDashboardReportScreen from "./AccountDashboardReportScreen";

const ExpenseManagementScreen = () => {
  const { expenseList,
    expenseLoading,
    expenseError,
    fetchExpenses,
    expenseApproveList,
    expenseApproveLoading,
    expenseApproveError,
    fetchExpenseApprove,
    disbursementList,
    disbursementLoading,
    disbursementbLoading,
    disbursementError,
    fetchDisbursementList,
    disbursementApproveError,
    disbursementApproveLoading,
    disbursementApproveList,
    setDisbursementApproveError,
    setDisbursementApproveLoading,
    setDisbursementApproveList,
    fetchDisbursementApprove,
    yearError,
    yearLoading,
    yearList,
    setSelectedYear,
    selectedYear,
    dashboardSummary, dashboardSummaryLoading, dashboardSummaryError,
    netBalanceReport, netBalanceLoading, netBalanceError,
    totalExpenseData, totalExpenseLoading, totalExpenseError,
    disbursementReportData, disbursementReportLoading, disbursementReportError,
    expenseReportData, expenseReportLoading, expenseReportError,
    rejectionReportData, rejectionReportLoading, rejectionReportError,
    onRefresh,
    setDisbursementList,
        setDisbursementError,
        setDisbursementLoading,
        onDisRefresh,
        onExpRefresh,
  } = ExpenseManagementController(); // Add if needed for tracking
  const [selectedTab, setSelectedTab] = useState(0);
  const [disabledTabs, setDisabledTabs] = useState([]);

    useEffect(() => {
          const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_') || '{}');
          const { per_name_sub_json } = storedUserInfo?.user_permissions?.expense_mgmt || {};
  
        
          const disabledTabIndices = [];
          if (per_name_sub_json?.acc_dashboard === 0) disabledTabIndices.push(0);
          if (per_name_sub_json?.expense_req === 0) disabledTabIndices.push(1);
          if (per_name_sub_json?.disbursement_req === 0) disabledTabIndices.push(2);
          if (per_name_sub_json?.appr_expense_disburse === 0) disabledTabIndices.push(3);
  
          setDisabledTabs(disabledTabIndices);
  
          if (disabledTabIndices.includes(selectedTab)) {
              const firstEnabledTab = [0, 1].find(tab => !disabledTabIndices.includes(tab));
              setSelectedTab(firstEnabledTab ?? 0);
          }
      }, [selectedTab]);
  

  const handleTabChange = (index) => {
    setSelectedTab(index);
  };

  return (
    <div style={styles.container}>
      <div className="title-container" style={{ paddingBottom: 20 }}>
        <h2 className="title">Expense Management</h2>
      </div>
<div>
      <Tabs
        tabs={["Account Dashboard", "Expenses", "Disbursements", "Approvals"]}
        selectedIndex={selectedTab}
        onTabChange={handleTabChange}
        disabledTabs={disabledTabs}
      >
        {selectedTab === 0 && !disabledTabs.includes(0) &&
        <AccountDashboardScreen
          yearList={yearList}
          selectedYear={selectedYear}
          setSelectedYear={setSelectedYear}
          yearError={yearError}
          yearLoading={yearLoading}
          dashboardData={dashboardSummary}
          dashboardLoading={dashboardSummaryLoading}
          dashboardError={dashboardSummaryError}
          setSelectedTab={setSelectedTab}
          onRefresh={onRefresh}
        />}
        {selectedTab === 1 && !disabledTabs.includes(1) &&
        <ExpenseListScreen
          expenseList={expenseList}
          expenseLoading={expenseLoading}
          expenseError={expenseError}
          onRefresh={onRefresh}
          fetchExpenses={fetchExpenses} />}
          {selectedTab === 2 && !disabledTabs.includes(2) &&
        <DisbursementsListScreen 
          disbursementList ={disbursementList} 
          disbursementbLoading={disbursementbLoading} 
          disbursementError={disbursementError} 
        onRefresh={onDisRefresh}
        setDisbursementList={setDisbursementList}
        setDisbursementLoading={setDisbursementLoading}
        setDisbursementError={setDisbursementError}
        fetchDisbursementList={fetchDisbursementList}
        />}
        {selectedTab === 3 && !disabledTabs.includes(3) &&
        <ExpenseApprovalsScreen
          expenseApproveList={expenseApproveList}
          expenseApproveLoading={expenseApproveLoading}
          expenseApproveError={expenseApproveError}
          onRefresh={onExpRefresh}
          fetchExpenseApprove={fetchExpenseApprove} />}
      </Tabs>

        {selectedTab === 0 ? (
          <AccountDashboardReportScreen
            selectedYear={selectedYear}
            netBalanceReport={netBalanceReport}
            netBalanceLoading={netBalanceLoading}
            netBalanceError={netBalanceError}
            totalExpenseData={totalExpenseData}
            totalExpenseLoading={totalExpenseLoading}
            totalExpenseError={totalExpenseError}
            disbursementReportData={disbursementReportData}
            disbursementReportLoading={disbursementReportLoading}
            disbursementReportError={disbursementReportError}
            expenseReportData={expenseReportData}
            expenseReportLoading={expenseReportLoading}
            expenseReportError={expenseReportError}
            rejectionReportData={rejectionReportData}
            rejectionReportLoading={rejectionReportLoading}
            rejectionReportError={rejectionReportError}
          />
        ) : (
          null
        )
        }
      </div>
      {selectedTab === 3 ? (
        <div className="content-container">
          <  DisbursementApprovalsScreen
            disbursementApproveList={disbursementApproveList}
            disbursementApproveLoading={disbursementApproveLoading}
            disbursementApproveError={disbursementApproveError}
            onRefresh={onDisRefresh}
            setDisbursementApproveError={setDisbursementApproveError}
            setDisbursementApproveLoading={setDisbursementApproveLoading}
            setDisbursementApproveList={setDisbursementApproveList}
          />
        </div>
      ) : (
        null
      )
      }
    </div>
  );
};

const styles = {
  container: {
    width: "95%",
    margin: "auto",
  }
};

export default ExpenseManagementScreen;
